var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeSvgrepoCom3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2041:2353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07099 4.03601H3.58008V7.52692H7.07099V4.03601Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5287 0.54541V2.29086H22.7832V4.03632H24.5287V11.0181H26.2741V12.7636H24.5287V14.509H26.2741H28.0196V11.0181H33.2559V12.7636H35.0014V11.0181V0.54541H24.5287ZM33.2559 9.27268H26.2741V2.29086H33.2559V9.27268Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5124 4.03601H28.0215V7.52692H31.5124V4.03601Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07099 28.4728H3.58008V31.9637H7.07099V28.4728Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2689 24.9817H24.5234V26.7272H26.2689V24.9817Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5423 33.709H15.7969V35.4544H17.5423V33.709Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2904 26.7273H17.5449V28.4727H19.2904V26.7273Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2904 30.2179H17.5449V31.9633H19.2904V30.2179Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9955 21.4906H33.25V23.2361H34.9955V21.4906Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83725 21.4906H0.0917969V23.2361H1.83725V21.4906Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.83725 12.7633H0.0917969V14.5088H1.83725V12.7633Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2878 2.29102V4.03647H15.7969V5.78193H21.0332V4.03647V2.29102H19.2878Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2541 14.5094V16.2549H29.7631V18.0003H24.5268V16.2549H22.7813V18.0003H19.2904V19.7458H24.5268V21.4912H21.0359H19.2904V19.7458H17.545V21.4912H15.7995V19.7458H14.054V21.4912H12.3086V23.2367H15.7995V24.9821H17.545V23.2367H21.0359V24.9821H19.2904V26.7276H21.0359V30.2185H22.7813V31.9639H24.5268V30.2185H29.7631V26.7276H31.5086V24.9821H29.7631V21.4912H26.2722V19.7458H29.7631V21.4912H31.5086V19.7458H33.2541V18.0003H34.9995V16.2549V14.5094H33.2541ZM28.0177 23.2367V28.473H22.7813V23.2367H28.0177Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7858 11.0183H21.0404V12.7638H19.2949V14.5092V16.2547H21.0404V14.5092H22.7858V12.7638H24.5313V11.0183H22.7858Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7858 33.709H19.2949V35.4544H22.7858V33.709Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8001 2.29102H14.0547V4.03647H15.8001V2.29102Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7669 14.5094H28.0215V16.2549H29.7669V14.5094Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5091 12.7633H29.7637V14.5088H31.5091V12.7633Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.81381 21.4906H7.06836V23.2361H8.81381V21.4906Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5645 33.7094V26.7276H12.31V24.9821V23.2367H10.5645V24.9821H5.32816V23.2367H3.58271H1.83725V24.9821H0.0917969V35.4549H10.5645H14.0554V33.7094H10.5645ZM8.81907 33.7094H1.83725V26.7276H8.81907V33.7094Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3138 11.0183H10.5684V12.7638H12.3138V11.0183Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.31 0.54541H10.5645H0.0917969V11.0181H1.83725V12.7636H3.58271V11.0181H5.32816V12.7636H7.07361V11.0181H10.5645V7.52723H12.31V5.78177H10.5645V2.29086H12.31H14.0554V0.54541H12.31ZM8.81907 9.27268H1.83725V2.29086H8.81907V9.27268Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7806 5.7821H21.0352V7.52756H22.7806V5.7821Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2904 0.54541H17.5449V2.29086H19.2904V0.54541Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0373 11.0181V9.27268H19.2918V7.52722H17.5463V9.27268H14.0554V7.52722H12.31V9.27268V11.0181H14.0554V14.509H8.81907V12.7636H7.07362V14.509H1.83725V16.2545H5.32816V18H0.0917969V19.7454H5.32816V21.4909H7.07362V19.7454H8.81907V21.4909H10.5645V19.7454H14.0554V18H12.31V16.2545H14.0554H15.8009V18H17.5463H19.2918V16.2545H17.5463V14.509H15.8009V11.0181H21.0373V11.0181ZM10.5645 18H7.07362V16.2545H10.5645V18Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7995 28.4726V26.7271V24.9817H14.054V26.7271H12.3086V28.4726H14.054V30.2181H12.3086V31.9635H15.7995V30.2181H17.545V28.4726H15.7995Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5053 31.9634V30.2179H29.7598V31.9634H24.5234V33.7088H28.0143V35.4543H29.7598V33.7088H33.2507V35.4543H34.9962V33.7088V31.9634H31.5053Z",
    fill: "#11B7B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2552 24.9817V26.7271H31.5098V28.4726H35.0007V26.7271V24.9817H33.2552Z",
    fill: "#11B7B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2041:2353"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0917969,
    y: 0.54541,
    width: 34.9091,
    height: 34.9091,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeSvgrepoCom3);
export default __webpack_public_path__ + "static/media/qr-code-svgrepo-com 3.8632a6d4.svg";
export { ForwardRef as ReactComponent };